import * as React from "react";
import { useState } from "react";
import { Box, Typography, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { FAGhostButton, FAPrimaryButton } from "../FAControls";
import { FA_DIALOG_PAPER_SX } from "../FALayout";

// The odometer capture dialog for the H&S vehicle step — its own draft state, so it does
// not belong in the step's already-long render.

export function OdometerDialog({ value, isSaving, onClose, onSave }) {
  const [draft, setDraft] = useState(value);

  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth sx={FA_DIALOG_PAPER_SX}>
      <DialogTitle sx={{ fontSize: "1.05rem", fontWeight: 700 }}>Update odometer</DialogTitle>
      <DialogContent>
        {/* A plain static label + bordered input (matching vehicles.html's own
            .modal-label/.modal-input) rather than FATextField's floating label — this
            app has no Roboto loaded and MUI's outlined notch gap assumes Roboto's line
            metrics, so a floating label clips against the notch with the Inter font
            actually in use. A static label sidesteps the notch mechanism entirely. */}
        <Typography sx={{ fontSize: "0.68rem", fontWeight: 700, color: "rgba(255,255,255,0.5)", textTransform: "uppercase", letterSpacing: "0.06em", mb: "6px" }}>
          Odometer (km)
        </Typography>
        <Box
          component="input"
          type="number"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          autoFocus
          sx={{
            width: "100%",
            backgroundColor: "#0D1117",
            border: "1px solid rgba(255,255,255,0.1)",
            borderRadius: "8px",
            padding: "10px 12px",
            color: "#fff",
            fontFamily: "inherit",
            fontSize: "0.9rem",
            outline: "none",
            boxSizing: "border-box",
            "&:focus": { borderColor: "rgba(253,185,64,0.5)" },
            "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": { WebkitAppearance: "none", margin: 0 },
          }}
        />
      </DialogContent>
      <DialogActions sx={{ p: "14px 20px" }}>
        <FAGhostButton onClick={onClose}>Cancel</FAGhostButton>
        <Box sx={{ flex: 1 }} />
        <FAPrimaryButton onClick={() => onSave(draft)} disabled={isSaving}>
          {isSaving ? "Saving…" : "Save"}
        </FAPrimaryButton>
      </DialogActions>
    </Dialog>
  );
}

